import type { Role } from "@/app/role";

// Mirrors lendcord-core's dto response/request records exactly — see
// docs/flows/join-enterprise-request-cycle.md in lendcord-core for the
// full FE integration contract.

export type JoinEnterpriseDecision = "APPROVE" | "REJECT";

// A stored request row is never NOT_APPLIED (that status is derived, only
// meaningful on the applicant's own profile view) — so the enterprise-side
// listing only ever sees these three.
export type JoinEnterpriseRequestStatus = "IN_PROGRESS" | "APPROVED" | "REJECTED";

export interface JoinEnterpriseRequestListItem {
  userId: string;
  readableId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  currentRole: Role;
  status: JoinEnterpriseRequestStatus;
  requestedAt: string;
  decidedAt: string | null;
  decidedByReadableId: string | null;
  remarks: string | null;
}

// branchId is only consulted on APPROVE, and only required when the
// enterprise has more than one branch (auto-picked when they have exactly
// one, 409 LEND-114 if they have none) — see JoinRequestDecisionDialog.
export interface JoinEnterpriseDecisionRequest {
  decision: JoinEnterpriseDecision;
  remarks: string;
  branchId?: string;
}

export interface JoinEnterpriseDecisionResponse {
  userId: string;
  readableId: string;
  branchId: string | null;
  requestStatus: JoinEnterpriseRequestStatus;
}

// Filter options for the enterprise's listing — no NOT_APPLIED, same
// reasoning as the status type above.
export const JOIN_ENTERPRISE_STATUS_FILTERS: JoinEnterpriseRequestStatus[] = ["IN_PROGRESS", "APPROVED", "REJECTED"];
export type JoinEnterpriseStatusFilter = JoinEnterpriseRequestStatus;
